import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AvlCheckbox } from '../../../../Shared/Inputs/Checkbox/AvlCheckbox';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import styles from './GroupByControl.module.css';

const groupByOptions = [
    { value: 'folder', label: 'Folder' },
];

export const GroupByControl = React.forwardRef(({ onGroupByChange, initialIsGroupBy = false, initialGroupByOption = 'folder' }, ref) => {
    const [isGroupBy, setIsGroupBy] = useState(initialIsGroupBy);
    const [groupByOption, setGroupByOption] = useState(initialGroupByOption);

    const handleIsGroupByChange = (event) => {
        const isGroupByValue = event.target.checked;
        setIsGroupBy(isGroupByValue);
        onGroupByChange({
            isGroupBy: isGroupByValue,
            groupByOption: isGroupByValue ? groupByOption : null,
        });
    };

    const handleGroupByOptionChange = (event) => {
        const groupByOptionValue = event.target.value;
        setGroupByOption(groupByOptionValue);
        onGroupByChange({
            isGroupBy,
            groupByOption: groupByOptionValue,
        });
    };

    const resetGroupBy = () => {
        setIsGroupBy(false);
        setGroupByOption('folder');
        onGroupByChange({
            isGroupBy: false,
            groupByOption: null,
        });
    };

    React.useImperativeHandle(ref, () => ({
        reset: resetGroupBy,
    }));

    return (
        <div className={styles.groupByContainer}>
            {isGroupBy && (
                <FormControl
                    sx={{ minWidth: '120px' }}
                    size="small"
                >
                    <InputLabel id="group-by-select-label">Group By</InputLabel>
                    <Select
                        labelId="group-by-select-label"
                        label="Group By"
                        value={groupByOption}
                        onChange={handleGroupByOptionChange}
                        disabled={true}
                        variant="outlined"
                    >
                        {groupByOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
            <AvlCheckbox
                label={'Group By'}
                value={isGroupBy}
                onChange={handleIsGroupByChange}
            />
        </div>
    );
});

GroupByControl.propTypes = {
    onGroupByChange: PropTypes.func.isRequired,
    initialIsGroupBy: PropTypes.bool,
    initialGroupByOption: PropTypes.string,
};

GroupByControl.displayName = 'GroupByControl';
